import type { HistoryEntry } from '../../domain/history';
import type { HistoryPort } from '../../ports/history';

/**
 * Zgodovina v pomnilniku — za teste in kot rezerva, kadar IndexedDB ni
 * dosegljiv (zasebni način, zavrnjena kvota). Ista pogodba kot IndexedDB
 * različica, brez trajnosti.
 */
export function createMemoryHistory(initial: readonly HistoryEntry[] = []): HistoryPort {
  // Najnovejši prvi — enak red, kot ga vrne indeks `at` v obratni smeri.
  let entries: HistoryEntry[] = [...initial].sort((a, b) => b.at - a.at);

  return {
    recent(limit) {
      return Promise.resolve(entries.slice(0, limit).map((entry) => ({ ...entry })));
    },
    append(entry) {
      entries = [entry, ...entries.filter((e) => e.id !== entry.id)];
      return Promise.resolve();
    },
    replaceAll(next) {
      entries = [...next].sort((a, b) => b.at - a.at);
      return Promise.resolve();
    },
    clearAll() {
      entries = [];
      return Promise.resolve();
    },
    clearStation(stationId) {
      entries = entries.filter((e) => e.stationId !== stationId);
      return Promise.resolve();
    },
  };
}
